import { render, staticRenderFns } from "./btnGroup.vue?vue&type=template&id=033cdd81&scoped=true&"
import script from "./btnGroup.vue?vue&type=script&lang=js&"
export * from "./btnGroup.vue?vue&type=script&lang=js&"
import style0 from "./btnGroup.vue?vue&type=style&index=0&id=033cdd81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033cdd81",
  null
  
)

export default component.exports